import { motion } from "motion/react";
import { SEVERITY_LEVELS } from "../../shared/types";

function sevColor(sev: number): string {
  if (sev >= 2) return "var(--malicious)";
  if (sev >= 1) return "var(--suspicious)";
  return "var(--safe)";
}

/** Retro segmented severity readout: 0–3 across four blocks. */
export function SeverityGauge({
  severity,
  confidence,
  animate = true,
}: {
  severity: number;
  confidence?: number;
  /** kept for API compatibility with callers that pass a size */
  size?: number;
  animate?: boolean;
}) {
  const color = sevColor(severity);
  const levelIdx = Math.max(0, Math.min(3, Math.round(severity)));

  return (
    <div className="mono w-full">
      <div className="flex items-end justify-between">
        <span className="display text-[46px] leading-none" style={{ color }}>
          {severity.toFixed(2)}
        </span>
        <span className="text-[11px] uppercase tracking-[0.1em]" style={{ color }}>
          {SEVERITY_LEVELS[levelIdx]}
        </span>
      </div>

      <div className="mt-2 flex gap-[3px]">
        {[0, 1, 2, 3].map((lvl) => {
          const fill = Math.max(0, Math.min(1, severity - lvl));
          return (
            <div key={lvl} className="meter flex-1" style={{ color }}>
              <motion.div
                className="meter-solid"
                style={{ background: color }}
                initial={animate ? { width: 0 } : false}
                animate={{ width: `${fill * 100}%` }}
                transition={{ duration: 0.4, delay: animate ? lvl * 0.07 : 0, ease: "easeOut" }}
              />
            </div>
          );
        })}
      </div>

      <div className="mt-1 flex justify-between text-[9.5px] uppercase tracking-[0.08em] opacity-60">
        {SEVERITY_LEVELS.map((l) => (
          <span key={l}>{l}</span>
        ))}
      </div>

      {confidence !== undefined && (
        <div className="mt-2 text-[10.5px] opacity-70">conf {confidence.toFixed(2)}</div>
      )}
    </div>
  );
}

export { sevColor };
